import { Input } from "./ui/input";

/**
 * Input especializado para el Código Catastral que fuerza el prefijo `0502-`.
 *
 * - Visualiza el prefijo `0502-` como texto no editable a la izquierda.
 * - El usuario sólo tipea la parte variable (ej. `04-01-U01-123`).
 * - La prop `value` externa siempre incluye el prefijo completo `0502-XXXX`.
 * - Si `value` viene sin prefijo (data legada) o con distinto prefijo, se
 *   normaliza: la porción visible es lo que sigue al primer separador
 *   (`-` o vacío) para no perder los caracteres tipeados por el usuario.
 *
 * Props:
 *   value: string — valor completo con prefijo (ej. "0502-04-01-U01").
 *   onChange: (nuevoValor) => void — recibe el valor completo con prefijo.
 *   disabled, placeholder, ...rest — pass-through a <Input>.
 */
const PREFIJO = "0502-";

export function stripCatastralPrefix(v) {
  const s = String(v || "");
  if (s.startsWith(PREFIJO)) return s.slice(PREFIJO.length);
  // Si trae `0502` sin guion, lo tratamos igual
  if (s.startsWith("0502")) return s.slice(4).replace(/^-/, "");
  return s;
}

export function withCatastralPrefix(rest) {
  const r = String(rest || "").trim();
  if (!r) return "";
  return PREFIJO + r;
}

export function CatastralInput({ value, onChange, disabled, placeholder, testId, className, ...rest }) {
  const rest_ = stripCatastralPrefix(value);
  return (
    <div className={`flex items-stretch rounded-md border border-input bg-white overflow-hidden focus-within:ring-2 focus-within:ring-green-600 ${disabled ? "opacity-60" : ""} ${className || ""}`}>
      <span
        className="inline-flex items-center px-2.5 bg-green-50 border-r border-input text-green-800 font-mono text-sm select-none"
        data-testid={testId ? `${testId}-prefix` : undefined}
      >
        0502-
      </span>
      <Input
        value={rest_}
        onChange={e => onChange(withCatastralPrefix(e.target.value))}
        disabled={disabled}
        placeholder={placeholder || "04-01-U01-..."}
        data-testid={testId}
        className="border-0 rounded-none focus-visible:ring-0 focus-visible:ring-offset-0 font-mono h-9"
        {...rest}
      />
    </div>
  );
}

export default CatastralInput;
